export const initHubspot = () => {
  const script = document.createElement('script');
  script.src = 'https://js.hs-scripts.com/21805390.js';
  script.async = true;
  document.getElementsByTagName('body')[0].appendChild(script);
};
